import React, { useEffect, useRef, useState } from "react";
import SelectedFileCard from "../SelectedFileCard";
import SecondaryBtn from "../../../../../../../components/Buttons/SecondaryBtn";
import PrimaryBtn from "../../../../../../../components/Buttons/PrimaryBtn";
import UploadFromRepoModal from "../../../../../../../components/FileUploadToS3/UploadFromRepoModal";
import api from "../../../../../../../api/api";
import { useAuth } from "../../../../../../../features/auth/AuthContext";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import GoogleDriveUpload from "../../../../../../../components/FileRepo/GoogleDriveUpload/GoogleDriveUpload";
import BackButton from "../../../../../../../components/BackButton/BackButton";
import { validateFilesForUpload } from "../../../../../../../components/FileRepo/utils/fileValidation";
import Loader from "./Loader";
import useBranding from "../../../../../../../hooks/useBranding";

const MAX_LINKS = 3;
const POLL_INTERVAL_MS = 20000; // poll bulk status every 20s

/* ----------------------------- link helpers ----------------------------- */

// validate a pasted URL (youtube only)
function parseLinkUrl(rawUrl) {
  const url = (rawUrl || "").trim();
  if (!url) return { valid: false, error: "Please paste a URL." };

  let parsed;
  try {
    parsed = new URL(url);
  } catch {
    return { valid: false, error: "That doesn't look like a valid URL." };
  }

  const host = parsed.hostname.replace(/^www\./, "");
  const isYoutube =
    host === "youtube.com" || host === "m.youtube.com" || host === "youtu.be";

  // ⛔ only YouTube links allowed here
  if (!isYoutube) {
    return { valid: false, error: "Please paste a valid YouTube link." };
  }

  // let videoId = "";
  // if (host === "youtu.be") {
  //   videoId = parsed.pathname.slice(1);                      // youtu.be/ABC123
  // } else if (parsed.pathname.startsWith("/embed/")) {
  //   videoId = parsed.pathname.split("/embed/")[1];           // youtube.com/embed/ABC123
  // } else if (parsed.pathname.startsWith("/shorts/")) {
  //   videoId = parsed.pathname.split("/shorts/")[1];          // youtube.com/shorts/ABC123
  // } else if (parsed.pathname.startsWith("/live/")) {
  //   videoId = parsed.pathname.split("/live/")[1];            // youtube.com/live/ABC123
  // } else {
  //   videoId = parsed.searchParams.get("v") || "";            // youtube.com/watch?v=ABC123
  // }
  // videoId = (videoId || "").split("/")[0];

  // if (!videoId) {
  //   return { valid: false, error: "Couldn't find a video id in that link." };
  // }


  if (!isYoutube) {
    return {
      valid: false,
      error: "Please paste a valid YouTube link.",
    };
  }
  return { valid: true, type: "youtube", rawUrl: url };
}

/* ------------------------------ component ------------------------------- */


const UploadFiles = ({
  isCreateCourse = false,
  handleFiles = () => { },
  course,
  teacher_id,
  createLessonCount,
  handleSave,
  closeModal,
  goBack = null,
  selectedFiles,
  setSelectedFiles,
  selectedRepoFiles,
  setSelectedRepoFiles,
  setLoadingText,
  setLoad,
  makeLinkRow,
  links,                 // 👈 from parent
  setLinks
}) => {
  const fileInputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [isOpenMyFiles, setIsOpenMyFiles] = useState(false); // state to open the upload from my files modal
  const [loading, setLoading] = useState(false); // state to show loading when files are being uploaded
  const { token } = useAuth();
  // true while ANY link row is still analysing (spinner showing)
  const isAnyLinkLoading = links.some(
    (r) => r.loading || r.status === "pending" || r.status === "queued"
  );
  const globalState = useSelector((state) => state.globalState);

  // interval handle for the shared bulk status poller
  const pollRef = useRef(null);
  const brandconfig = useBranding()



  // Custom icon for Google Drive upload in UploadFiles
  const UploadFilesGoogleDriveIcon = () => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_597_159451"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={24}
      >
        <rect width={24} height={24} fill="#1C1B1F" />
      </mask>

      <g mask="url(#mask0_597_159451)">
        <path
          d="M5.50078 21.5C5.21745 21.5 4.92995 21.4125 4.63828 21.2375C4.34661 21.0625 4.13411 20.8583 4.00078 20.625L1.50078 16.25C1.36745 16.0167 1.30078 15.7292 1.30078 15.3875C1.30078 15.0458 1.36745 14.7583 1.50078 14.525L8.00078 3.375C8.13411 3.14167 8.34661 2.9375 8.63828 2.7625C8.92995 2.5875 9.21745 2.5 9.50078 2.5H14.5008C14.7841 2.5 15.0716 2.5875 15.3633 2.7625C15.6549 2.9375 15.8674 3.14167 16.0008 3.375L20.5508 11.175C20.1674 11.075 19.7716 11.0083 19.3633 10.975C18.9549 10.9417 18.5508 10.9583 18.1508 11.025L14.3508 4.5H9.65078L3.30078 15.4L5.65078 19.5H13.5508C13.7341 19.8833 13.9466 20.2417 14.1883 20.575C14.4299 20.9083 14.7091 21.2167 15.0258 21.5H5.50078ZM7.25078 17L6.52578 15.725L11.1008 7.75H12.9008L15.4258 12.15C15.1424 12.3667 14.8799 12.6042 14.6383 12.8625C14.3966 13.1208 14.1841 13.3917 14.0008 13.675L12.0008 10.2L9.25078 15H13.3508C13.2341 15.3167 13.1466 15.6417 13.0883 15.975C13.0299 16.3083 13.0008 16.65 13.0008 17H7.25078Z"
          fill="#0068FF"
        />

        <path
          d="M22.5 15.4L21.1 14L18 17.1V14.5H16V20.5H22V18.5H19.425L22.5 15.4Z"
          fill="#0068FF"
        />
      </g>
    </svg>
  );


  // ✕ button: instead of removing the whole input row, just RESET this row
  // back to a fresh empty state (clears the pasted URL + any loading/saved
  // status), so the "Generate" button shows again and the input is editable.
  const handleRemoveLink = (id) => {

    const row = links.find((r) => r.id === id);
    const wasSaved = !!row?.saved;
    setLinks((prev) =>
      prev.map((row) =>
        row.id === id
          ? {
            ...makeLinkRow(), // fresh empty fields (value, status, flags, etc.)
            id: row.id,       // keep the same row id so React doesn't remount it
          }
          : row,
      ),
    );

    if (wasSaved) {
      toast.success("Link removed successfully.");
    }

    //     // remove that one row (per requirement)
    // setLinks((prev) => prev.filter((row) => row.id !== id));
  };

  const handleClose = () => {
    setSelectedFiles([]);
    setSelectedRepoFiles([]);
    setLinks([makeLinkRow()]); // reset link rows on close
    closeModal?.();
  };

  const MAX_FILES = 4;
  const MAX_TOTAL_SIZE = 500 * 1024 * 1024; // 500MB
  const ALLOWED_EXTENSIONS = new Set([
    ".txt",
    ".xlsx",
    ".docx",
    ".png",
    ".jpeg",
    ".jpg",
    ".pdf",
    ".pptx",
  ]);

  const getFileExtension = (filename) =>
    filename.slice(filename.lastIndexOf(".")).toLowerCase();

  const openMyFilesModal = () => {
    setIsOpenMyFiles(true);
  };

  /* --------------------------- link row handlers --------------------------- */

  const updateLinkRow = (id, patch) => {
    setLinks((prev) =>
      prev.map((row) => (row.id === id ? { ...row, ...patch } : row)),
    );
  };

  const handleLinkChange = (id, value) => {
    updateLinkRow(id, { value, error: "", saved: false });
  };

  const handleAddLink = () => {
    setLinks((prev) => {
      if (prev.length >= MAX_LINKS) {
        toast.error(`You can add up to ${MAX_LINKS} links.`);
        return prev;
      }
      return [...prev, makeLinkRow()];
    });
  };

  // Generate: validate, lock the row, call /courses/yt-transcribe/.
  // On `queued`, keep the loader on and mark the row "pending" with its task_id —
  // the shared poll effect below resolves it to "Saved" when the task succeeds.
  const handleGenerate = async (id) => {
    const row = links.find((r) => r.id === id);
    if (!row) return;

    const result = parseLinkUrl(row.value);
    if (!result.valid) {
      updateLinkRow(id, { error: result.error });
      return;
    }

    try {
      // lock input + show spinner for THIS row only
      updateLinkRow(id, {
        loading: true,
        error: "",
        locked: true,
        status: "queued",
      });

      const { data: res } = await api.post(
        "/courses/yt-transcribe/",
        { youtube_url: result.rawUrl },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        },
      );

      const taskId = res?.task_id || "";
      const status = res?.status || "";

      if (status === "queued" && taskId) {
        // keep the loader on; the poll effect will flip this row to "Saved"
        updateLinkRow(id, {
          loading: true,
          locked: true,
          saved: false,
          status: "pending",
          taskId,
          pollUrl: res?.poll_url || "",
          youtubeUrl: res?.youtube_url || "",
          rawUrl: result.rawUrl,
          type: result.type,
          error: "",
        });
      } else {
        // no queue (unexpected) → treat as immediately done
        updateLinkRow(id, {
          loading: false,
          saved: true,
          locked: true,
          status: "success",
          taskId,
          youtubeUrl: res?.youtube_url || "",
          rawUrl: result.rawUrl,
          type: result.type,
          error: "",
        });
      }
    } catch (err) {
      console.error("yt-transcribe failed:", err);
      updateLinkRow(id, {
        loading: false,
        locked: false, // unlock so they can retry
        status: "error",
        error: "Couldn't analyse this link. Please try again.",
      });
    }
  };

  /* ----------------------- bulk status polling effect ---------------------- */
  // While any row is "pending", poll the bulk endpoint every 20s with ALL
  // pending task_ids at once. Each task that returns "success" flips its row
  // to "Saved"; others keep their loader and keep being polled.
  useEffect(() => {
    const pendingIds = links
      .filter((r) => r.status === "pending" && r.taskId)
      .map((r) => r.taskId);

    // nothing pending → stop any running interval
    if (pendingIds.length === 0) {
      if (pollRef.current) {
        clearInterval(pollRef.current);
        pollRef.current = null;
      }
      return;
    }

    // an interval is already running → it re-reads pending ids each tick,
    // so newly-added tasks get picked up without starting a second timer
    if (pollRef.current) return;

    const poll = async () => {
      // read the freshest pending ids from state each tick
      let ids = [];
      setLinks((prev) => {
        ids = prev
          .filter((r) => r.status === "pending" && r.taskId)
          .map((r) => r.taskId);
        return prev; // no state change here, just reading
      });

      if (ids.length === 0) return;

      try {
        const { data } = await api.get(
          `/courses/yt-transcribe/status/bulk/?task_ids=${ids.join(",")}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Token ${token}`,
            },
          },
        );

        const results = Array.isArray(data?.results) ? data.results : [];
        if (results.length === 0) return;

        setLinks((prev) =>
          prev.map((r) => {
            const match = results.find((res) => res.task_id === r.taskId);
            if (!match) return r;

            if (match.status === "success") {
              return {
                ...r,
                loading: false,
                saved: true,
                locked: true,
                status: "success",
                docxUrl: match.docx_s3_url || "",
                recordId: match.record_id || "",
                videoTitle: match.video_title || "",
                language: match.language || "",
                error: "",
              };
            }

            if (match.status === "failed" || match.status === "error") {
              return {
                ...r,
                loading: false,
                locked: false,
                status: "error",
                error:
                  match.error ||
                  match.message ||
                  "Transcription failed. Please try again.",
              };
            }

            // still pending → leave as-is
            return r;
          }),
        );
      } catch (err) {
        console.error("bulk status poll failed:", err);
        // keep polling; a transient error shouldn't kill the loop
      }
    };

    // fire once immediately, then on an interval
    poll();
    pollRef.current = setInterval(poll, POLL_INTERVAL_MS);

    return () => {
      if (pollRef.current) {
        clearInterval(pollRef.current);
        pollRef.current = null;
      }
    };
    // re-run whenever rows change (covers a 2nd URL becoming pending)
  }, [links, token]);

  // safety: clear the interval if the component unmounts
  useEffect(() => {
    return () => {
      if (pollRef.current) {
        clearInterval(pollRef.current);
        pollRef.current = null;
      }
    };
  }, []);

  const handleFilesInternal = async (newFiles) => {
    // 🔧 Normalize FileList or any array-like to a true Array
    const filesArray = Array.from(newFiles ?? []);

    // 1️⃣ Filter unsupported file types (don't return, just filter out)
    const supportedFiles = filesArray.filter((file) =>
      ALLOWED_EXTENSIONS.has(getFileExtension(file.name)),
    );

    const rejectedFiles = filesArray.filter(
      (file) => !ALLOWED_EXTENSIONS.has(getFileExtension(file.name)),
    );

    if (rejectedFiles.length > 0) {
      const names = rejectedFiles.map((f) => f.name).join(", ");
      toast.error(
        `Unsupported file type${rejectedFiles.length > 1 ? "s" : ""}: ${names}. ` +
        `Only allowed types will be processed.`,
      );
    }

    // If no supported files remain, stop here
    if (supportedFiles.length === 0) return;

    // 2️⃣ Validate files for corruption and protection
    const { validFiles, invalidFiles } =
      await validateFilesForUpload(supportedFiles);

    if (invalidFiles.length > 0) {
      const invalidList = invalidFiles
        .map((f) => `${f.file.name} (${f.reason})`)
        .join(", ");
      toast.error(`File is corrupted or invalid: ${invalidList}`);
    }

    // If no valid files remain, stop here
    if (validFiles.length === 0) return;

    // 3️⃣ Merge with already selected files
    const combinedFiles = [...selectedFiles, ...validFiles];

    // 4️⃣ Remove duplicates
    const uniqueFiles = combinedFiles.filter(
      (file, index, self) =>
        index ===
        self.findIndex(
          (f) =>
            f.name === file.name &&
            f.size === file.size &&
            f.lastModified === file.lastModified,
        ),
    );

    // 5️⃣ Max file count
    if (uniqueFiles.length > MAX_FILES) {
      toast.error(`Maximum ${MAX_FILES} files are allowed.`);
      return;
    }

    const duplicateCount = combinedFiles.length - uniqueFiles.length;
    if (duplicateCount > 0) {
      toast.error(
        duplicateCount === 1
          ? "The file is already uploaded."
          : `Files are already uploaded.`,
      );
    }

    // 6️⃣ Total size check
    const totalSize = uniqueFiles.reduce((acc, file) => acc + file.size, 0);
    if (totalSize > MAX_TOTAL_SIZE) {
      toast.error("Total file size cannot exceed 500MB.");
      return;
    }

    // ✅ All validations passed
    setSelectedFiles(uniqueFiles);
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    setIsDragging(false);
    if (e.dataTransfer?.files?.length) {
      await handleFilesInternal(e.dataTransfer.files);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleChange = async (e) => {
    if (e.target.files?.length) {
      await handleFilesInternal(e.target.files);
      e.target.value = null;
    }
  };

  const removeFile = (indexToRemove) => {
    const updatedFiles = selectedFiles.filter(
      (_, index) => index !== indexToRemove,
    );
    setSelectedFiles(updatedFiles);
    return toast.success("File removed successfully.");
  };

  const removeRepoFile = (indexToRemove) => {
    const updatedFiles = selectedRepoFiles.filter(
      (_, index) => index !== indexToRemove,
    );
    setSelectedRepoFiles(updatedFiles);
    return toast.success("File removed successfully.");
  };

  const combinedSelectedFiles = [
    ...selectedFiles.map((file, index) => ({
      source: "local",
      file,
      index,
    })),
    ...selectedRepoFiles.map((file, index) => ({
      source: "repo",
      file,
      index,
    })),
  ];

  const handleFileSubmit = async (
    parentId,
    filesArg = null,
    repoFilesArg = null,
    closeAfter = true,
  ) => {
    const filesToUpload = Array.isArray(filesArg) ? filesArg : selectedFiles;
    const repoFilesToUpload = Array.isArray(repoFilesArg)
      ? repoFilesArg
      : selectedRepoFiles;

    if (
      (filesToUpload?.length === 0 || filesToUpload == null) &&
      (repoFilesToUpload?.length === 0 || repoFilesToUpload == null)
    )
      return;

    const effectiveParentId = (parentId && Array.isArray(parentId)
      ? parentId
      : [parentId]) || [course?.file_repo_folder_id];
    const formData = new FormData();

    if (filesToUpload?.length > 0) {
      filesToUpload.forEach((file) => {
        formData.append("files", file);
      });
    }

    if (repoFilesToUpload?.length > 0) {
      repoFilesToUpload.forEach((file) => {
        if (file?.id) {
          formData.append("file_ids", file.id);
        }
      });
    }

    formData.append("type", "file");
    if (effectiveParentId?.length > 0) {
      effectiveParentId.forEach((id) => formData.append("parent_id", id));
    }
    try {
      // setLoading(true);
      const response = await api.post("/upload/", formData, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });

      if (response.status === 200 || response.status === 201) {
        toast.success("Files uploaded successfully.");
        return response;
      } else {
        toast.error("File Upload Failed. Please try again later.");
        return response;
      }
    } catch (error) {
      toast.error("File Upload Failed. Please try again later.");
      throw error;
    } finally {
      // setLoading(false);
      if (closeAfter) handleClose();
    }
  };

  const handleSkip = () => {
    handleSave?.(true);
    setSelectedFiles([]);
    setSelectedRepoFiles([]);
    setLinks([makeLinkRow()])
  };

  // collect successfully-generated youtube urls (status success / saved)
  const getGeneratedYoutubeUrls = () =>
    links
      .filter((r) => r.saved && (r.youtubeUrl || r.rawUrl))
      .map((r) => r.youtubeUrl || r.rawUrl);

  const hasGeneratedLinks = getGeneratedYoutubeUrls().length > 0;

  const handleSubmit = async () => {
    const setBusy = setLoad
      ? (busy) => setLoad(busy)
      : (busy) => setLoading(busy);

    try {
      if (isCreateCourse) {
        // Create the course first, then upload files into its folder.
        const youtubeUrls = getGeneratedYoutubeUrls();
        const response = await handleSave?.(false, youtubeUrls); // 👈 pass urls
        const courseData = response?.data?.data || response?.data || {};
        const parentId =
          courseData?.file_repo_folder ||
          courseData?.course?.file_repo_folder ||
          course?.file_repo_folder_id;

        setBusy(true);
        setLoadingText?.("Uploading files to course...");
        await handleFileSubmit(parentId);
        setLoadingText?.("Course creation in progress...");

      } else {
        // Create lessons first, then upload files into each lesson folder.
        const lessonResponse = await handleSave?.(false, selectedFiles, selectedRepoFiles);
        const lessons = lessonResponse?.data?.lessons;

        if (Array.isArray(lessons) && lessons.length > 0) {
          const folderIds = lessons
            .map((l) => l?.folder?.folder_id || l?.folder_id || null)
            .filter(Boolean);

          if (folderIds.length > 0) {
            setBusy(true);
            setLoadingText?.("Uploading files to lessons...");
            await handleFileSubmit(folderIds);
            setLoadingText?.("Lesson generation in progress...");
          }
        }
      }
    } catch (error) {
      toast.error("File upload failed. Please try again later.");
    } finally {
      setBusy(false);
      handleClose();
    }
  };

  const hanldleRepoFiles = (newFiles) => {
    if (!Array.isArray(newFiles) || newFiles?.length === 0) return;

    const currentTotalCount =
      selectedFiles.length + selectedRepoFiles.length + newFiles.length;

    if (currentTotalCount > MAX_FILES) {
      toast.error(`Maximum ${MAX_FILES} files can be uploaded.`);
      return;
    }

    const uniqueNewFiles = newFiles.filter(
      (newFile) =>
        !selectedRepoFiles.some(
          (repoFile) => repoFile?.id && repoFile?.id === newFile?.id,
        ),
    );

    if (uniqueNewFiles.length === 0) return true;

    setSelectedRepoFiles((prev) => [...prev, ...uniqueNewFiles]);
    return true;
  };

  return (
    <>
      <div className="relative">
        {loading && <Loader text="Uploading Files..." />}

        {/* -------------------- Drop YouTube / Website Link -------------------- */}

        {
          (globalState.enabled_modules?.includes('youtube_modul') && !isCreateCourse) && (
            <div className="mb-4">
              <p className="text-[#1C1B1F] text-[0.95rem] font-medium mb-2">
                Drop YouTube Link
              </p>

              <div className="flex flex-col gap-2">
                {links.map((row) => {
                  const isLocked = row.loading || row.saved || row.locked;
                  return (
                    <div key={row.id} className="flex flex-col gap-1">
                      <div className="flex items-center gap-2">
                        <div
                          className={`flex items-center gap-2 flex-1 border rounded-[8px] px-3 py-2  max-[365px]:!px-[5px] max-[365px]:!py-[4px] ${row.error ? "border-[#e53935]" : "border-[#d9d9d9]"
                            } ${isLocked ? "bg-[#FAFAFA]" : ""}`}
                        >
                          <span className="text-[#8a8a8a] flex-shrink-0">
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="1.6"
                              className="w-[18px] h-[18px] max-[365px]:w-[14px] max-[365px]:h-[14px]"
                            >
                              <circle cx="12" cy="12" r="9" />
                              <path d="M3 12h18M12 3c2.5 2.7 2.5 15.3 0 18M12 3c-2.5 2.7-2.5 15.3 0 18" />
                            </svg>
                          </span>

                          <input
                            type="text"
                            value={row.value}
                            placeholder="Paste Your URL here..."
                            readOnly={isLocked}
                            onChange={(e) =>
                              handleLinkChange(row.id, e.target.value)
                            }
                            onKeyDown={(e) =>
                              e.key === "Enter" &&
                              !isLocked &&
                              handleGenerate(row.id)
                            }
                            className={`flex-1 bg-transparent outline-none text-[0.9rem] text-[#222] border-none max-[420px]:text-[11px] ${isLocked ? "cursor-default" : ""
                              }`}
                          />

                          {/* right-side state: loading → saved → generate */}
                          {row.loading ? (
                            <span className="flex items-center gap-1.5 text-[#0068FF] text-[0.85rem] max-[420px]:text-[11px] flex-shrink-0">
                              <span
                                style={{
                                  width: "14px",
                                  height: "14px",
                                  border: "2px solid #0068FF",
                                  borderTopColor: "transparent",
                                  borderRadius: "50%",
                                  display: "inline-block",
                                  animation: "yt-spin 0.8s linear infinite",
                                }}
                              />
                              Analysing video
                              <style>{`@keyframes yt-spin { to { transform: rotate(360deg); } }`}</style>
                            </span>
                          ) : row.saved ? (
                            <span className="flex items-center gap-1 text-[#1aa251] text-[0.85rem] max-[420px]:text-[11px] font-medium flex-shrink-0">
                              <i className="fa-solid fa-check" /> Saved
                            </span>
                          ) : (
                            <button
                              type="button"
                              onClick={() => handleGenerate(row.id)}
                              disabled={!row.value.trim()}
                              className={`text-[0.9rem] font-medium flex-shrink-0 bg-transparent border-none max-[420px]:text-[11px] ${!row.value.trim()
                                ? "text-[#c2c2c2] cursor-not-allowed"
                                : "text-[#0068FF] cursor-pointer"
                                }`}
                            >
                              Generate
                            </button>
                          )}
                        </div>

                        <button
                          type="button"
                          onClick={() => handleRemoveLink(row.id)}
                          className="text-[#888] hover:text-[#e53935] flex-shrink-0 px-1 bg-transparent border-none cursor-pointer"
                          aria-label="Clear link"
                        >
                          ✕
                        </button>
                      </div>

                      {row.error && (
                        <p className="text-[#e53935] text-[0.75rem] pl-1">
                          {row.error}
                        </p>
                      )}
                    </div>
                  );
                })}
              </div>

              {/* + Add Link (disabled for now — single input only) */}
              {/*
          {links.length < MAX_LINKS && (
            <button
              type="button"
              onClick={handleAddLink}
              className="flex items-center gap-1 mt-2 text-[#0068FF] text-[0.85rem] font-medium bg-transparent border-none cursor-pointer"
            >
              <span className="text-[1.1rem] leading-none">+</span> Add Link
            </button>
          )}
          */}
            </div>
          )
        }


        <div className="flex items-stretch justify-between my-4 w-[100%] flex-col md:flex-row">
          <div className="flex flex-col gap-2 w-[100%] md:w-[50%]">
            {/* FILES label + upload buttons on the same row */}
            <div className="flex items-center justify-between gap-2 flex-wrap">
              <span className="text-[rgb(125,129,117)] text-[0.9rem] font-medium">
                FILES
              </span>

              {/* <div className="flex items-center gap-2"> */}
              <div className="flex items-center gap-2 max-[999px]:flex-col max-[767px]:flex-row max-[524px]:flex-col">
                <button
                  onClick={openMyFilesModal}
                  className="flex items-center gap-2 bg-[#FAFAFA] border border-[#d9d9d9] rounded-[8px] px-3 py-2"
                >
                  <span>
                    <svg
                      width="20"
                      height="16"
                      viewBox="0 0 20 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2 16C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H8L10 2H18C18.55 2 19.0208 2.19583 19.4125 2.5875C19.8042 2.97917 20 3.45 20 4V14C20 14.55 19.8042 15.0208 19.4125 15.4125C19.0208 15.8042 18.55 16 18 16H2ZM2 14H18V4H9.175L7.175 2H2V14Z"
                        fill="#0068FF"
                      />
                    </svg>
                  </span>
                  <span className="text-[#1C1B1F] text-[0.85rem] font-medium whitespace-nowrap">
                    {`${brandconfig?.filename ? brandconfig?.filename === "My Files" ? "Upload from My Files" : brandconfig?.filename : "Upload from My Files"}`}
                  </span>
                </button>

                <button className="bg-[#FAFAFA] border border-[#d9d9d9] rounded-[8px] px-3 py-2">
                  <GoogleDriveUpload
                    onFilesDownloaded={handleFilesInternal}
                    setIsLoading={setLoading}
                    Icon={UploadFilesGoogleDriveIcon}
                    textClassName="!text-[#1C1B1F] !text-[0.85rem] !font-medium !whitespace-nowrap"
                  />
                </button>
              </div>
            </div>

            <div
              className="flex flex-col gap-2 aling-center w-full items-center cursor-pointer border-[2px] !border-dashed border-[#c0c0c0] p-4 md:p-8 rounded-md"
              onClick={handleClick}
              onDrop={handleDrop}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
            >
              <svg
                width="42"
                height="30"
                viewBox="0 0 42 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 30C7.236 30 4.87833 29.0412 2.927 27.1235C0.975667 25.2058 0 22.8622 0 20.0925C0 17.6078 0.799333 15.4225 2.398 13.5365C3.99667 11.6505 5.97933 10.5332 8.346 10.1845C8.987 7.19483 10.4903 4.75 12.856 2.85C15.2213 0.95 17.936 0 21 0C24.6213 0 27.6933 1.26133 30.216 3.784C32.7387 6.30667 34 9.37867 34 13V14H34.6155C36.7232 14.164 38.4808 15.0115 39.8885 16.5425C41.2962 18.0732 42 19.8923 42 22C42 24.2307 41.2308 26.1217 39.6925 27.673C38.1538 29.2243 36.2692 30 34.0385 30H23.1155C22.1052 30 21.25 29.65 20.55 28.95C19.85 28.25 19.5 27.3948 19.5 26.3845V15.4305L15.8 19.069L13.6925 16.981L21 9.673L28.3075 16.981L26.2 19.069L22.5 15.4305V26.3845C22.5 26.5385 22.5642 26.6795 22.6925 26.8075C22.8205 26.9358 22.9615 27 23.1155 27H34C35.4 27 36.5833 26.5167 37.55 25.55C38.5167 24.5833 39 23.4 39 22C39 20.6 38.5167 19.4167 37.55 18.45C36.5833 17.4833 35.4 17 34 17H31V13C31 10.2333 30.025 7.875 28.075 5.925C26.125 3.975 23.7667 3 21 3C18.2333 3 15.875 3.975 13.925 5.925C11.975 7.875 11 10.2333 11 13H9.9615C8.0665 13 6.4325 13.6833 5.0595 15.05C3.6865 16.4167 3 18.0667 3 20C3 21.9333 3.68333 23.5833 5.05 24.95C6.41667 26.3167 8.06667 27 10 27H15V30H10Z"
                  fill="#0068FF"
                />
              </svg>

              <div className="text-black font-normal text-[1rem]">
                {window.innerWidth > 768 ? "Drag & drop files or" : ""}{" "}
                <span className="font-medium underline text-[#0068FF] ">
                  Browse
                </span>
              </div>
              <div className="text-[#555555] font-normal text-[0.8rem]">
                Supported file types: JPEG, PNG, DOCX, PDF, PPTX, XLSX, TXT
              </div>
              <input
                type="file"
                multiple
                ref={fileInputRef}
                onChange={handleChange}
                className="hidden"
                accept=".txt,.xlsx,.docx,.png,.jpeg,.jpg,.pdf,.pptx"
              />
            </div>
          </div>
          <div className="w-px self-stretch bg-[#D9D9D9] mx-4" />
          <div className="flex flex-col gap-2 w-[100%] md:w-[50%]">
            <span className="text-[#7D8175] text-[0.9rem] font-medium">
              UPLOADED FILES ({combinedSelectedFiles.length})
            </span>
            <div className="flex flex-col gap-2 w-full border-[2px] border-[#c0c0c0] p-2 rounded-md min-h-[150px]">
              {combinedSelectedFiles.length > 0 ? (
                <div className="grid grid-cols-1 gap-2">
                  {combinedSelectedFiles.map(({ source, file, index }) => (
                    <SelectedFileCard
                      key={`${source}-${file?.id ?? file?.name ?? index
                        }-${index}`}
                      file={file}
                      removeFile={
                        source === "repo" ? removeRepoFile : removeFile
                      }
                      indexToRemove={index}
                      isRepoFile={source === "repo"}
                    />
                  ))}
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
        {goBack ? (
          <div className="flex justify-between items-center mt-4 px-2">
            <BackButton marginB="0px" onClick={goBack} buttonName="Back" />
            <div className="flex justify-end gap-3">
              <SecondaryBtn handleClick={handleSkip} label="Skip for now" />
              <PrimaryBtn
                disabled={
                  selectedFiles?.length === 0 && selectedRepoFiles?.length === 0 && !hasGeneratedLinks || isAnyLinkLoading
                }
                handleClick={handleSubmit}
                label="Save"
              />
            </div>
          </div>
        ) : (
          <div className="flex justify-end mt-4 px-2 gap-3">
            <SecondaryBtn handleClick={handleSkip} label="Skip for now" />
            <PrimaryBtn
              disabled={
                selectedFiles?.length === 0 && selectedRepoFiles?.length === 0 && !hasGeneratedLinks || isAnyLinkLoading
              }
              handleClick={handleSubmit}
              label="Save"
            />
          </div>
        )}

        <UploadFromRepoModal
          open={isOpenMyFiles}
          setOpen={setIsOpenMyFiles}
          setSelectedRepoFiles={hanldleRepoFiles}
          selectedRepoFiles={selectedRepoFiles}
          maxFiles={MAX_FILES}
          allowedTypes={Array.from(ALLOWED_EXTENSIONS).map((ext) => ext.slice(1))}
        />
      </div>
    </>
  );
};

export default UploadFiles;